import React from 'react'
import { BasicStyledComponent, DSCompareDeal, DSCompareDealGallery } from 'shared-definitions/types'
import CompareDeal from './CompareDeal'
import styles from './CompareDealGallery.module.css'
import clsx from 'clsx'
import HorizontalGalleryAlternate from '../service/HorizontalGalleryAlternate'
import { bpToPx } from 'shared-code/responsive'
import styleUtils from 'shared-components/styles/util.module.css'
import { GalleryPagination } from './GalleryPagination'

interface CompareDealGalleryProps extends DSCompareDealGallery, BasicStyledComponent {}

export const CompareDealGallery: React.FC<CompareDealGalleryProps> = ({ className, deals }) => (
  <HorizontalGalleryAlternate
    className={clsx(className, styleUtils.mobileFull)}
    initial={deals}
    slidesPerView={1.1}
    spaceBetween={12}
    slidesOffsetAfter={15}
    slidesOffsetBefore={15}
    breakpoints={{
      [bpToPx('sm')]: { slidesPerView: 2, slidesOffsetAfter: 0, slidesOffsetBefore: 0 },
      [bpToPx('lg')]: { slidesPerView: 4, slidesOffsetAfter: 0, slidesOffsetBefore: 0 },
    }}
    render={(item: DSCompareDeal, index) => <CompareDeal key={index} {...item} />}
    renderPagination={opts => (
      <GalleryPagination
        className={styles.pagination}
        currentPage={opts.currentPage}
        totalPages={opts.totalPages}
        onPageChange={opts.onPageChange}
      />
    )}
  />
)
